// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"14e65d96","209":"f6317ed5","841":"61e3284a","878":"ac211390"}[chunkId] + ".chunk.js";
};